import { AvailableChildrenType, SugarElementInfo } from "../../SugarElementInfo";

import { commonContentAttributes } from "./commonContentAttributes";

export const okpo1t: SugarElementInfo = {
    name: "okpo1t",
    availableChildren: { type: AvailableChildrenType.Any },
    attributes: commonContentAttributes,
};
